import { lazy } from '../../shared/deployment';

export const QRCodeWrapper = lazy(() => import('./qr-code-scanner/qr-code-wrapper'));
export const QRCodeRequest = lazy(() => import('./qr-code-scanner/qr-code-request'));
export const QRCodeValidate = lazy(() => import('./qr-code-scanner/qr-code-validate'));
